<template>
  <div class="typeList_ui">
    <div class="type_top_mode" v-if="finalDatas.layout=='top'">
      <div class="type_warp">
        <van-tabs :before-change="beforeChange" ref="tabs" :background="finalDatas.backgroundColor" @click="(name)=>chooseType(name,'T')" class="picType" v-if="finalDatas.menuType=='pic'">
          <van-tab :title="item.name" ref="tab" v-for="(item,i) in finalDatas.groupList" :key="i" :name="item.id" :title-style="item.active?typeStyleActive+picStyle[i]:typeStyle+picStyle[i]">

          </van-tab>
        </van-tabs>
        <van-tabs ref="tabs" :before-change="beforeChange" :background="finalDatas.backgroundColor" @click="(name)=>chooseType(name,'T')" :type="style.type" class="typeBox" :class="finalDatas.parentStyle" :color="style.color" :title-inactive-color="style.inactiveColor" :title-active-color="style.activeColor" v-else>
          <van-tab :title="item.name" ref="tab" v-for="(item,i) in finalDatas.groupList" :key="i" :name="item.id" :title-style="item.active?typeStyleActive:typeStyle">

          </van-tab>
        </van-tabs>

        <van-tabs ref="childType" :background="finalDatas.backgroundColor" :class="finalDatas.childStyle" :style="typeSonTabs" v-if="initChildType&&parentTypeList.children&&parentTypeList.children.length>0" type="card" class="childType" :title-inactive-color="style.childInactiveColor" :color="style.childColor" :title-active-color="style.childActiveColor">

          <van-tab :title="item.name" v-for="(item,j) in parentTypeList.children" :key="j" :name="item.id">
            <div class="sticky-nav" v-if="closeTypeCondition!='T'">
              <div class="type_name"> </div>
              <div class="sort-warp">
                <div class="sort-item" :class="soldMode" @click="soldSort" v-if="showSold=='T'&&parentGoodsList[j]&&parentGoodsList[j].showSold=='T'">
                  销量<i class="iconfont iconxiasanjiaoxing"></i>
                </div>
                <div class="sort-item" :class="priceMode" @click="priceSort">
                  价格<i class="iconfont iconxiasanjiaoxing"></i>
                </div>
              </div>

            </div>
            <div class="goodsList" v-if="parentGoodsList[j]">
              <waterfall col="2" :data="parentGoodsList[j].goods" :width="itemWidth" v-if="parentGoodsList[j]&&finalDatas.goodsLayout=='grid'&&closeWaterfall!='T'" class="goods-list-box waterfall">

                <div class="box" v-for="(item,i) in parentGoodsList[j].goods" :key="i" @click="goGoods(item)" :style="goodsStyle" v-if="i<parentTypeList.number">
                  <div class="img-box">
                    <img class="img" :src="item.logo+'?imageMogr2/thumbnail/334x'" :style="imgStyle" />
                    <div class="label" v-if="finalDatas.isShowTag&&item.goodsattr&&item.goodsattr!=''" :style="labColor">
                      {{item.goodsattr}}
                      <div class="labelBg" :style="labBg"></div>
                    </div>
                    <div class="hotelName" v-if="item.supplierName&&item.supplierName!=''&&showListHotelName!='F'">
                      <b>{{item.supplierName}}</b>
                    </div>
                    <div class="hotelName" v-else-if="item.hotelName&&item.hotelName!=''&&showListHotelName!='F'">
                      <b>{{item.hotelName}}</b>
                    </div>
                  </div>
                  <div class="goods-content">
                    <div class="goods-name">{{item.name}}</div>
                    <!-- <div class="goods-desc" v-if="item.secondTitle">{{item.secondTitle}}</div>
                                    <div class="goods-desc" v-else></div> -->
                    <div class="goods-discount" v-if="item.extraInfo&&item.extraInfo.discountList">
                      <div class="goods-discount-item" v-if="item.extraInfo.discountList.length>0" v-for="(discount,j) in item.extraInfo.discountList" :key="j">
                        <span>{{discount.discountTxt}}</span>
                      </div>
                    </div>
                    <div class="price-box" :style="priceColor" v-if="item.price>=0">
                      <div class="price" v-if="item.openType=='apply'">
                        <span class="cur-price">
                          <b :style="priceSize">免费开通</b>
                        </span>
                      </div>
                      <div class="price" v-else-if="item.directlyBuy=='F'">
                        <span class="cur-price">
                          <b :style="priceSize">价格面议</b>
                        </span>
                      </div>
                      <div class="price" v-else-if="!(item.price<=0&&item.credit<=0)">
                        <span class="cur-price" v-if="item.price>0">
                          <i>￥</i>
                          <b :style="priceSize">{{item.price}}</b>
                        </span>
                        <div class="credit" v-if="item.credit>0">
                          <span>
                            <em v-if="item.price>0"><span v-if="priceOrCredit!='T'">+</span><span v-if="priceOrCredit=='T'">/</span></em>
                            {{item.credit}}
                          </span>
                          <b>{{creditName}}</b>
                        </div>
                        <div class="qi" v-if="item.type=='scenic'||item.type=='room'||item.type=='diy'||item.skuFlag||item.type=='ticket'">起</div>
                        <span class="proposedPrice" v-if="item.proposedPrice>0">
                          ￥{{item.proposedPrice}}
                        </span>
                      </div>
                      <div class="price" v-else-if="item.type=='scenic'||item.type=='room'||item.type=='diy'||item.skuFlag||item.type=='ticket'">
                        <span class="cur-price">
                          <i>￥</i>
                          <b :style="priceSize">{{item.price}}</b>
                        </span>
                        <div class="qi">起</div>
                      </div>
                      <div class="price" v-else>
                        <span class="cur-price free">
                          <b :style="priceSize">免费</b>
                        </span>
                      </div>

                      <div class="add-shopCar" @click.stop="isShowSku(item)" v-if="isCloseCart!='T'&&parentTypeList.isCart&&item.type=='goods'&&(item.isWechatProfitSharing!='T'||isOpenProfitSharingShopCart=='T')">
                        <i class="iconfont iconjia1"></i>
                      </div>
                    </div>
                  </div>

                  <div class="no-stock" v-if="item.stock!=undefined&&item.stock<=0"><img src="https://xcx.ihotel.cn/mall-chain/no-stock.png"></img></div>
                </div>

              </waterfall>
              <div class="goods-list-box" :class="finalDatas.goodsLayout" v-else>
                <div class="goods-list-container">
                  <div class="box" v-for="(item,i) in parentGoodsList[j].goods" :key="i" @click="goGoods(item)" :style="goodsStyle" v-if="parentGoodsList[j]&&i<parentTypeList.number">
                    <div class="img-box" :class="{'img-box-square':isSquarePic=='T'}">
                      <img class="img" :src="item.logo+thumbSuffix" :style="imgStyle" />
                      <div class="label" v-if="finalDatas.isShowTag&&item.goodsattr&&item.goodsattr!=''" :style="labColor">
                        {{item.goodsattr}}
                        <div class="labelBg" :style="labBg"></div>
                      </div>
                      <div class="hotelName" v-if="item.supplierName&&item.supplierName!=''&&showListHotelName!='F'">
                        <b>{{item.supplierName}}</b>
                      </div>
                      <div class="hotelName" v-else-if="item.hotelName&&item.hotelName!=''&&showListHotelName!='F'">
                        <b>{{item.hotelName}}</b>
                      </div>
                    </div>
                    <div class="goods-content">
                      <div class="goods-name">{{item.name}}</div>
                      <!-- <div class="goods-desc" v-if="item.secondTitle">{{item.secondTitle}}</div>
                                        <div class="goods-desc" v-else></div> -->
                      <div class="price-box" :style="priceColor" v-if="item.price>=0">
                        <div class="price" v-if="item.openType=='apply'">
                          <span class="cur-price">
                            <b :style="priceSize">免费开通</b>
                          </span>
                        </div>
                        <div class="price" v-else-if="item.directlyBuy=='F'">
                          <span class="cur-price">
                            <b :style="priceSize">价格面议</b>
                          </span>
                        </div>
                        <div class="price" v-else-if="!(item.price<=0&&item.credit<=0)">
                          <span class="cur-price" v-if="item.price>0">
                            <i>￥</i>
                            <b :style="priceSize">{{item.price}}</b>
                          </span>
                          <div class="credit" v-if="item.credit>0">
                            <span>
                              <em v-if="item.price>0"><span v-if="priceOrCredit!='T'">+</span><span v-if="priceOrCredit=='T'">/</span></em>
                              {{item.credit}}
                            </span>
                            <b>{{creditName}}</b>
                          </div>
                          <div class="qi" v-if="item.type=='scenic'||item.type=='room'||item.type=='diy'||item.skuFlag||item.type=='ticket'">起</div>
                          <span class="proposedPrice" v-if="item.proposedPrice>0">
                            ￥{{item.proposedPrice}}
                          </span>
                        </div>
                        <div class="price" v-else-if="item.type=='scenic'||item.type=='room'||item.type=='diy'||item.skuFlag||item.type=='ticket'">

                          <span class="cur-price">
                            <i>￥</i>
                            <b :style="priceSize">{{item.price}}</b>
                          </span>
                          <div class="qi">起</div>

                        </div>
                        <div class="price" v-else>
                          <span class="cur-price free">
                            <b :style="priceSize">免费</b>
                          </span>
                        </div>
                        <div class="add-shopCar" @click.stop="isShowSku(item)" v-if="isCloseCart!='T'&&parentTypeList.isCart&&item.type=='goods'&&(item.isWechatProfitSharing!='T'||isOpenProfitSharingShopCart=='T')">
                          <i class="iconfont iconjia1"></i>
                        </div>
                      </div>
                    </div>

                    <div class="no-stock" v-if="item.stock!=undefined&&item.stock<=0"><img src="https://xcx.ihotel.cn/mall-chain/no-stock.png"></img></div>
                  </div>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
      <div class="sticky-nav" v-if="this.canRequest&&(!parentTypeList.children||parentTypeList.children.length==0)&&closeTypeCondition!='T'">
        <div class="type_name"> </div>
        <div class="sort-warp">
          <div class="sort-item" :class="soldMode" @click="soldSort" v-if="showSold=='T'">
            销量<i class="iconfont iconxiasanjiaoxing"></i>
          </div>
          <div class="sort-item" :class="priceMode" @click="priceSort">
            价格<i class="iconfont iconxiasanjiaoxing"></i>
          </div>
        </div>

      </div>
      <div class="goodsList" v-if="!parentTypeList.children||parentTypeList.children.length==0" :style="moduleBgColor">

        <waterfall col="2" :data="goodsList" :width="itemWidth" v-if="finalDatas.goodsLayout=='grid'&&closeWaterfall!='T'" class="goods-list-box waterfall">

          <div class="box" v-for="(item,i) in goodsList" :key="i" @click="goGoods(item)" :style="goodsStyle" v-if="i<parentTypeList.number">
            <div class="img-box">
              <img class="img" :src="item.logo+'?imageMogr2/thumbnail/334x'" :style="imgStyle" />
              <div class="label" v-if="finalDatas.isShowTag&&item.goodsattr&&item.goodsattr!=''" :style="labColor">
                {{item.goodsattr}}
                <div class="labelBg" :style="labBg"></div>
              </div>
              <div class="hotelName" v-if="item.supplierName&&item.supplierName!=''&&showListHotelName!='F'">
                <b>{{item.supplierName}}</b>
              </div>
              <div class="hotelName" v-else-if="item.hotelName&&item.hotelName!=''&&showListHotelName!='F'">
                <b>{{item.hotelName}}</b>
              </div>
            </div>
            <div class="goods-content">
              <div class="goods-name">{{item.name}}</div>
              <!-- <div class="goods-desc" v-if="item.secondTitle">{{item.secondTitle}}</div>
                        <div class="goods-desc" v-else></div> -->
              <div class="goods-discount" v-if="item.extraInfo&&item.extraInfo.discountList">
                <div class="goods-discount-item" v-if="item.extraInfo.discountList.length>0" v-for="(discount,j) in item.extraInfo.discountList" :key="j">
                  <span>{{discount.discountTxt}}</span>
                </div>
              </div>
              <div class="price-box" :style="priceColor">
                <div class="price" v-if="item.openType=='apply'">
                  <span class="cur-price">
                    <b :style="priceSize">免费开通</b>
                  </span>
                </div>
                <div class="price" v-else-if="item.directlyBuy=='F'">
                  <span class="cur-price">
                    <b :style="priceSize">价格面议</b>
                  </span>
                </div>
                <div class="price" v-else-if="!(item.price<=0&&item.credit<=0)">
                  <span class="cur-price" v-if="item.price>0">
                    <i>￥</i>
                    <b :style="priceSize">{{item.price}}</b>
                  </span>
                  <div class="credit" v-if="item.credit>0">
                    <span>
                      <em v-if="item.price>0"><span v-if="priceOrCredit!='T'">+</span><span v-if="priceOrCredit=='T'">/</span></em>
                      {{item.credit}}
                    </span>
                    <b>{{creditName}}</b>
                  </div>

                  <span class="proposedPrice" v-if="item.proposedPrice>0">
                    ￥{{item.proposedPrice}}
                  </span>
                </div>
                <div class="price" v-else>
                  <span class="cur-price free">
                    <b :style="priceSize">免费</b>
                  </span>
                </div>

                <div class="add-shopCar" @click.stop="isShowSku(item)" v-if="isCloseCart!='T'&&parentTypeList.isCart&&item.type=='goods'&&(item.isWechatProfitSharing!='T'||isOpenProfitSharingShopCart=='T')">
                  <i class="iconfont iconjia1"></i>
                </div>
              </div>
            </div>

            <div class="no-stock" v-if="item.stock!=undefined&&item.stock<=0"><img src="https://xcx.ihotel.cn/mall-chain/no-stock.png"></img></div>
          </div>

        </waterfall>
        <div class="goods-list-box" :class="finalDatas.goodsLayout" v-else>
          <div class="goods-list-container">
            <div class="box" v-for="(item,i) in goodsList" :key="i" @click="goGoods(item)" :style="goodsStyle" v-if="i<parentTypeList.number">
              <div class="img-box" :class="{'img-box-square':isSquarePic=='T'}">
                <img class="img" :src="item.logo+thumbSuffix" :style="imgStyle" />
                <div class="label" v-if="finalDatas.isShowTag&&item.goodsattr&&item.goodsattr!=''" :style="labColor">
                  {{item.goodsattr}}
                  <div class="labelBg" :style="labBg"></div>
                </div>
                <div class="hotelName" v-if="item.supplierName&&item.supplierName!=''&&showListHotelName!='F'">
                  <b>{{item.supplierName}}</b>
                </div>
                <div class="hotelName" v-else-if="item.hotelName&&item.hotelName!=''&&showListHotelName!='F'">
                  <b>{{item.hotelName}}</b>
                </div>
              </div>
              <div class="goods-content">
                <div class="goods-name">{{item.name}}</div>
                <!-- <div class="goods-desc" v-if="item.secondTitle">{{item.secondTitle}}</div>
                            <div class="goods-desc" v-else></div> -->
                <div class="price-box" :style="priceColor">
                  <div class="price" v-if="!(item.price<=0&&item.credit<=0)">
                    <span class="cur-price" v-if="item.price>0">
                      <i>￥</i>
                      <b :style="priceSize">{{item.price}}</b>
                    </span>
                    <div class="credit" v-if="item.credit>0">
                      <span>
                        <em v-if="item.price>0"><span v-if="priceOrCredit!='T'">+</span><span v-if="priceOrCredit=='T'">/</span></em>
                        {{item.credit}}
                      </span>
                      <b>{{creditName}}</b>
                    </div>
                    <div class="qi" v-if="item.type=='scenic'||item.type=='room'||item.type=='diy'||item.skuFlag||item.type=='ticket'">起</div>
                    <span class="proposedPrice" v-if="item.proposedPrice>0">
                      ￥{{item.proposedPrice}}
                    </span>
                  </div>
                  <div class="price" v-else>
                    <span class="cur-price free">
                      <b :style="priceSize">免费</b>
                    </span>
                  </div>
                  <div class="add-shopCar" @click.stop="isShowSku(item)" v-if="isCloseCart!='T'&&parentTypeList.isCart&&item.type=='goods'&&((item.isWechatProfitSharing!='T')||isOpenProfitSharingShopCart=='T')">
                    <i class="iconfont iconjia1"></i>
                  </div>
                </div>
              </div>

              <div class="no-stock" v-if="item.stock!=undefined&&item.stock<=0"><img src="https://xcx.ihotel.cn/mall-chain/no-stock.png"></img></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="type_left_mode" v-if="finalDatas.layout=='left'">
      <div class="type-box_warp" :style="background" ref="leftType">
        <div class="type-box" :class="{'fixed':fixed}">
          <div class="type_item" @click="chooseType(item.id,'T')" :style="item.active?typeStyleActive:typeStyle" :class="{'active':item.active}" v-for="(item,i) in finalDatas.groupList">
            <div class="type_item_desc"> 
              {{item.name}}
            </div>
            <div class="activeSta" v-if="item.active" :style="activeStaStyle"></div>
          </div>
        </div>
      </div>
      <div class="type_right_warp" v-if="isOnlyOne" ref="type_right_warp">
        <!-- <van-list v-model="loading" :finished="finished" finished-text="" @load="infinite"> -->
          <div class="type_right" v-for="(group,j) in finalDatas.groupList" :key="j" :id="'id'+group.id" v-if="!isLoading">

            <div class="typeTitle typePd">{{group.name}}</div>
            <div class="hotel" v-if="group.isRoom" @click="goHotelList">
              <div class="hotel_date">
                <div class="date">
                  {{hotelDate.today}}
                </div>
                <div class="date_desc">入住</div>
              </div>
              <div class="number">共1晚</div>
              <div class="hotel_date">
                <div class="date">
                  {{hotelDate.tomorrow}}
                </div>
                <div class="date_desc">离店</div>
              </div>
            </div>

            <div class="goodsList">
              <div class="goods-list-box mini-box" v-if="finalDatas.goodsShow=='two'">
                <div class="goods-list-container">
                  <div class="box MySkeleton" v-for="(item,i) in group.goodsTotal" :key="i" :style="goodsStyle" v-if="!group.isRequest">
                      <div class="img-box Skeleton-item" :class="{'img-box-square':isSquarePic=='T'}">
                          
                      </div>
                      <div class="goods-content">
                          <div class="Skeleton-item" style="height: 15px;margin-top: 5px;"></div>
                          <div class="Skeleton-item" style="height: 15px;margin-top: 5px;"></div>
                          <div class="Skeleton-item" style="height: 15px;margin-top: 5px;width: 50%;"></div>
                      </div>
                  </div>
                  <div class="box " v-for="(item,i) in group.goodsList" :key="i" @click="goGoods(item)" :style="goodsStyle" v-if="i<group.number">
                    <div class="img-box" :class="{'img-box-square':isSquarePic=='T'}">
                      <img class="img" :src="item.logo+thumbSuffix" :style="imgStyle" />
                      <div class="label" v-if="finalDatas.isShowTag&&item.goodsattr&&item.goodsattr!=''" :style="labColor">
                        {{item.goodsattr}}
                        <div class="labelBg" :style="labBg"></div>
                      </div>
                      <div class="hotelName" v-if="item.supplierName&&item.supplierName!=''&&showListHotelName!='F'">
                        <b>{{item.supplierName}}</b>
                      </div>
                      <div class="hotelName" v-else-if="item.hotelName&&item.hotelName!=''&&showListHotelName!='F'">
                        <b>{{item.hotelName}}</b>
                      </div>
                    </div>
                    <div class="goods-content">
                      <div class="goods-name">{{item.name}}</div>

                      <div class="price-box" :style="priceColor" v-if="item.price>=0">
                        <div class="price" v-if="item.openType=='apply'">
                          <span class="cur-price">
                            <b :style="priceSize">免费开通</b>
                          </span>
                        </div>
                        <div class="price" v-else-if="item.directlyBuy=='F'">
                          <span class="cur-price">
                            <b :style="priceSize">价格面议</b>
                          </span>
                        </div>
                        <div class="price" v-else-if="!(item.price<=0&&item.credit<=0)">
                          <span class="cur-price" v-if="item.price>0">
                            <i>￥</i>
                            <b :style="priceSize">{{item.price}}</b>
                          </span>
                          <div class="credit" v-if="item.credit>0">
                            <span>
                              <em v-if="item.price>0"><span v-if="priceOrCredit!='T'">+</span><span v-if="priceOrCredit=='T'">/</span></em>
                              {{item.credit}}
                            </span>
                            <b>{{creditName}}</b>
                          </div>
                          <div class="qi" v-if="item.type=='scenic'||item.type=='room'||item.type=='diy'||item.skuFlag||item.type=='ticket'">起</div>
                          <span class="proposedPrice" v-if="item.proposedPrice>0">
                            ￥{{item.proposedPrice}}
                          </span>
                        </div>
                        <div class="price" v-else-if="item.type=='scenic'||item.type=='room'||item.type=='diy'||item.skuFlag||item.type=='ticket'">

                          <span class="cur-price">
                            <i>￥</i>
                            <b :style="priceSize">{{item.price}}</b>
                          </span>
                          <div class="qi">起</div>

                        </div>
                        <div class="price" v-else>
                          <span class="cur-price free">
                            <b :style="priceSize">免费</b>
                          </span>
                        </div>
                        <div class="add-shopCar" @click.stop="isShowSku(item)" v-if="isCloseCart!='T'&&group.isCart&&item.type=='goods'&&(item.isWechatProfitSharing!='T'||isOpenProfitSharingShopCart=='T')">
                          <i class="iconfont iconjia1"></i>
                        </div>
                      </div>
                    </div>

                    <div class="no-stock" v-if="item.stock!=undefined&&item.stock<=0"><img src="https://xcx.ihotel.cn/mall-chain/no-stock.png"></img></div>
                  </div>
                </div>
              </div>
              <div class="MySkeleton skeleton-list" v-else-if="!group.isRequest">
                  <div v-for="(item,i) in group.goodsTotal" :key="i" class="goods-box">
                      <div class="box">
                          <div class="img-box">
                              <div class="img-box-content Skeleton-item"></div>
                          </div>
                          <div class="goods-content-common">
                              <div class="Skeleton-item" style="height: 15px;"></div>
                              <div class="Skeleton-item" style="height: 15px;margin-top: 5px;"></div>
                              <div class="Skeleton-item" style="height: 20px;margin-top: 10px;width: 50%;"></div>
                          </div>
                      </div>
                  </div>
              </div>
              <goodsListBig class="goodsListBig"  goodsType="goodsType"  :shopCar='group.isCart' :number="group.number" :goodsListData="group.goodsList" :totalRows="totalRows" :name="name" v-else-if="group.goodsList"></goodsListBig>
            </div>
          </div>
        <!-- </van-list> -->
      </div>
      <ScrollLoad class="type_right_warp" ref="scrollLoad" :refreshMethod="onRefresh" :loadMoreMethod="onLoad" v-else>
        <div class="type_right " :style="moduleBgColor" v-if="!isLoading">
          <van-tabs ref="childType" @scroll="scrollTab" scrollspy sticky :class="finalDatas.childStyle" swipe-threshold="1" :active="activeType" v-if="initChildType&&parentTypeList.children&&parentTypeList.children.length>0" type="card" @click="childTypeClick" @change="chooseChildType" class="childType" :title-inactive-color="style.childInactiveColor" :color="style.childColor" :title-active-color="style.childActiveColor">
            <div class="sticky-nav" :class="{'fixed-nav':isFixed}" v-if="closeTypeCondition!='T'">
              <div class="type_name"> {{childType.name}}</div>
              <div class="sort-warp">
                <div class="sort-item" :class="soldMode" @click="soldSort" v-if="showSold=='T'">
                  销量<i class="iconfont iconxiasanjiaoxing"></i>
                </div>
                <div class="sort-item" :class="priceMode" @click="priceSort">
                  价格<i class="iconfont iconxiasanjiaoxing"></i>
                </div>
              </div>

            </div>
            <van-tab :title="item.name" v-for="(item,i) in parentTypeList.children" :key="i" :name="item.id" :title-style="item.active?typeSonStyleActive:typeSonStyle">

              <div class="hotel" v-if="parentTypeList.isRoom&&i==0" @click="goHotelList">
                <div class="hotel_date">
                  <div class="date">
                    {{hotelDate.today}}
                  </div>
                  <div class="date_desc">入住</div>
                </div>
                <div class="number">共1晚</div>
                <div class="hotel_date">
                  <div class="date">
                    {{hotelDate.tomorrow}}
                  </div>
                  <div class="date_desc">离店</div>
                </div>
              </div>
              <div class="goodsList" v-if="parentGoodsList[i]">
                <div class="typeTitle">{{parentGoodsList[i].name}}</div>
                <div class="goods-list-box mini-box" v-if="finalDatas.goodsShow=='two'">
                  <div class="goods-list-container">
                    <div class="box " v-for="(item,i) in parentGoodsList[i].goods" :key="i" @click="goGoods(item)" :style="goodsStyle" v-if="parentGoodsList[i]&&i<parentTypeList.number">
                      <div class="img-box" :class="{'img-box-square':isSquarePic=='T'}">
                        <img class="img" :src="item.logo+thumbSuffix" :style="imgStyle" />
                        <div class="label" v-if="finalDatas.isShowTag&&item.goodsattr&&item.goodsattr!=''" :style="labColor">
                          {{item.goodsattr}}
                          <div class="labelBg" :style="labBg"></div>
                        </div>
                        <div class="hotelName" v-if="item.supplierName&&item.supplierName!=''&&showListHotelName!='F'">
                          <b>{{item.supplierName}}</b>
                        </div>
                        <div class="hotelName" v-else-if="item.hotelName&&item.hotelName!=''&&showListHotelName!='F'">
                          <b>{{item.hotelName}}</b>
                        </div>
                      </div>
                      <div class="goods-content">
                        <div class="goods-name">{{item.name}}</div>

                        <div class="price-box" :style="priceColor" v-if="item.price>=0">
                          <div class="price" v-if="item.openType=='apply'">
                            <span class="cur-price">
                              <b :style="priceSize">免费开通</b>
                            </span>
                          </div>
                          <div class="price" v-else-if="item.directlyBuy=='F'">
                            <span class="cur-price">
                              <b :style="priceSize">价格面议</b>
                            </span>
                          </div>
                          <div class="price" v-else-if="!(item.price<=0&&item.credit<=0)">
                            <span class="cur-price" v-if="item.price>0">
                              <i>￥</i>
                              <b :style="priceSize">{{item.price}}</b>
                            </span>
                            <div class="credit" v-if="item.credit>0">
                              <span>
                                <em v-if="item.price>0"><span v-if="priceOrCredit!='T'">+</span><span v-if="priceOrCredit=='T'">/</span></em>
                                {{item.credit}}
                              </span>
                              <b>{{creditName}}</b>
                            </div>
                            <div class="qi" v-if="item.type=='scenic'||item.type=='room'||item.type=='diy'||item.skuFlag||item.type=='ticket'">起</div>
                            <span class="proposedPrice" v-if="item.proposedPrice>0">
                              ￥{{item.proposedPrice}}
                            </span>
                          </div>
                          <div class="price" v-else-if="item.type=='scenic'||item.type=='room'||item.type=='diy'||item.skuFlag||item.type=='ticket'">

                            <span class="cur-price">
                              <i>￥</i>
                              <b :style="priceSize">{{item.price}}</b>
                            </span>
                            <div class="qi">起</div>

                          </div>
                          <div class="price" v-else>
                            <span class="cur-price free">
                              <b :style="priceSize">免费</b>
                            </span>
                          </div>
                          <div class="add-shopCar" @click.stop="isShowSku(item)" v-if="isCloseCart!='T'&&parentTypeList.isCart&&item.type=='goods'&&(item.isWechatProfitSharing!='T'||isOpenProfitSharingShopCart=='T')">
                            <i class="iconfont iconjia1"></i>
                          </div>
                        </div>
                      </div>

                      <div class="no-stock" v-if="item.stock!=undefined&&item.stock<=0"><img src="https://xcx.ihotel.cn/mall-chain/no-stock.png"></img></div>
                    </div>
                  </div>
                </div>
                <goodsListBig class="goodsListBig" goodsType="goodsType" :shopCar='parentTypeList.isCart' :number="parentTypeList.number" :goodsListData="parentGoodsList[i].goods" :totalRows="totalRows" :name="name" v-else></goodsListBig>
              </div>

            </van-tab>
          </van-tabs>
          <template v-if="!parentTypeList.children||parentTypeList.children.length==0">
            <div class="sticky-nav relative-nav" v-if="closeTypeCondition!='T'">
              <div class="type_name"></div>
              <div class="sort-warp">
                <div class="sort-item" :class="soldMode" @click="soldSort" v-if="showSold=='T'">
                  销量<i class="iconfont iconxiasanjiaoxing"></i>
                </div>
                <div class="sort-item" :class="priceMode" @click="priceSort">
                  价格<i class="iconfont iconxiasanjiaoxing"></i>
                </div>
              </div>

            </div>
            <div class="hotel" v-if="parentTypeList.isRoom" @click="goHotelList">
              <div class="hotel_date">
                <div class="date">
                  {{hotelDate.today}}
                </div>
                <div class="date_desc">入住</div>
              </div>
              <div class="number">共1晚</div>
              <div class="hotel_date">
                <div class="date">
                  {{hotelDate.tomorrow}}
                </div>
                <div class="date_desc">离店</div>
              </div>
            </div>

            <div class="goodsList">
              <div class="goods-list-box mini-box" v-if="finalDatas.goodsShow=='two'">
                <div class="goods-list-container">
                  <div class="box " v-for="(item,i) in goodsList" :key="i" @click="goGoods(item)" :style="goodsStyle" v-if="i<parentTypeList.number">
                    <div class="img-box" :class="{'img-box-square':isSquarePic=='T'}">
                      <img class="img" :src="item.logo+thumbSuffix" :style="imgStyle" />
                      <div class="label" v-if="finalDatas.isShowTag&&item.goodsattr&&item.goodsattr!=''" :style="labColor">
                        {{item.goodsattr}}
                        <div class="labelBg" :style="labBg"></div>
                      </div>
                      <div class="hotelName" v-if="item.supplierName&&item.supplierName!=''&&showListHotelName!='F'">
                        <b>{{item.supplierName}}</b>
                      </div>
                      <div class="hotelName" v-else-if="item.hotelName&&item.hotelName!=''&&showListHotelName!='F'">
                        <b>{{item.hotelName}}</b>
                      </div>
                    </div>
                    <div class="goods-content">
                      <div class="goods-name">{{item.name}}</div>

                      <div class="price-box" :style="priceColor" v-if="item.price>=0">
                        <div class="price" v-if="item.openType=='apply'">
                          <span class="cur-price">
                            <b :style="priceSize">免费开通</b>
                          </span>
                        </div>
                        <div class="price" v-else-if="item.directlyBuy=='F'">
                          <span class="cur-price">
                            <b :style="priceSize">价格面议</b>
                          </span>
                        </div>
                        <div class="price" v-else-if="!(item.price<=0&&item.credit<=0)">
                          <span class="cur-price" v-if="item.price>0">
                            <i>￥</i>
                            <b :style="priceSize">{{item.price}}</b>
                          </span>
                          <div class="credit" v-if="item.credit>0">
                            <span>
                              <em v-if="item.price>0"><span v-if="priceOrCredit!='T'">+</span><span v-if="priceOrCredit=='T'">/</span></em>
                              {{item.credit}}
                            </span>
                            <b>{{creditName}}</b>
                          </div>
                          <div class="qi" v-if="item.type=='scenic'||item.type=='room'||item.type=='diy'||item.skuFlag||item.type=='ticket'">起</div>
                          <span class="proposedPrice" v-if="item.proposedPrice>0">
                            ￥{{item.proposedPrice}}
                          </span>
                        </div>
                        <div class="price" v-else-if="item.type=='scenic'||item.type=='room'||item.type=='diy'||item.skuFlag||item.type=='ticket'">

                          <span class="cur-price">
                            <i>￥</i>
                            <b :style="priceSize">{{item.price}}</b>
                          </span>
                          <div class="qi">起</div>

                        </div>
                        <div class="price" v-else>
                          <span class="cur-price free">
                            <b :style="priceSize">免费</b>
                          </span>
                        </div>
                        <div class="add-shopCar" @click.stop="isShowSku(item)" v-if="isCloseCart!='T'&&parentTypeList.isCart&&item.type=='goods'&&(item.isWechatProfitSharing!='T'||isOpenProfitSharingShopCart=='T')">
                          <i class="iconfont iconjia1"></i>
                        </div>
                      </div>
                    </div>

                    <div class="no-stock" v-if="item.stock!=undefined&&item.stock<=0"><img src="https://xcx.ihotel.cn/mall-chain/no-stock.png"></img></div>
                  </div>
                </div>
              </div>
              <goodsListBig class="goodsListBig" goodsType="goodsType" :shopCar='parentTypeList.isCart' :number="parentTypeList.number" :goodsListData="goodsList" :totalRows="totalRows" :name="name" v-else></goodsListBig>
            </div>
          </template>

        </div>
        <div class="loading-img" v-else>
          <img src="https://xcx.ihotel.cn/mall/images/loading2.gif">
        </div>
      </ScrollLoad>

    </div>
    <layerSku ref="layerSku" :goodsId="goodsId" :goodsDetail="goodsDetail" :curInfo="curInfo" showBtn=true></layerSku>

  </div>
</template>

<script>
import api from "@/utils/api";
import {
  jAlert3
} from "@/base/jAlert/jAlert";
import {
  getStorage
} from '@/utils/wxuser';
import layerSku from "@/components/layerSku.vue";
import goodsListBig from "@/components/goodsListBig";
import ScrollLoad from '@/components/scrollLoad.vue';
import {
  Tab,
  Tabs
} from 'vant';
var config = {};
export default {
  name: "Title",
  props: {
    datas: Object
  },
  data() {
    return {
      user: getStorage('user'),
      finalDatas: {},
      goodsList: [],
      isSquarePic: getStorage('isSquarePic') || 'F',
      closeWaterfall: getStorage('closeWaterfall') || 'F',
      creditName: getStorage('creditName') || '积分',
      goodsId: '',
      goodsDetail: {},
      curInfo: {},
      canRequest: true,
      showListHotelName: getStorage('showListHotelName') || 'T',
      hotelDate: {
        today: moment(new Date()).format('MM月DD日'),
        tomorrow: moment(new Date()).add(1, 'days').format('MM月DD日')
      },
      parentTypeList: {},
      childType: {},
      initChildType: true,
      style: {},
      timer: null,
      parentGoodsList: [],
      fixed: false,
      customPack: getStorage('customPack'),
      stop: false,
      priceMode: '',
      soldMode: '',
      isFixed: false,
      goods_type_price_condition: 'F',
      showSold: 'T',
      closeTypeCondition: 'T',
      loading: false,
      isLoading: false,
      isOnlyOne: true,
      isScroll:false,
      observer: null

    };
  },
  computed: {
    moduleBgColor() {
      var style = "";
      if (this.finalDatas.moduleBgColor) {
        style += `background:${this.finalDatas.moduleBgColor};`;
      }
      return style;
    },
    background() {
      var style = ''

      style += `background:${this.finalDatas.backgroundColor};`
      return style
    },
    picStyle() {
      var style = ''
      if (this.finalDatas.layout == 'top' && this.finalDatas.menuType == 'pic') {
        style = []
        var styleItem = ''
        this.finalDatas.groupList.forEach(item => {
          styleItem += `background:url(${item.icon}) center top/auto 25px no-repeat;`
          style.push(styleItem)
        })
      }
      return style
    },
    typeStyle() {
      var style = ''
      if (this.finalDatas.layout != 'left') {
        if (this.finalDatas.parentStyle == 'qp') {
          style += `background:${this.finalDatas.qpColor};`
        }
      }
      style += `color:${this.finalDatas.color};`

      return style

    },
    typeSonTabs() {
      var style = ''
      if (this.finalDatas.parentStyle == 'qp') {
        style += `margin-top:-5px;`
      } else {
        style += `margin-top:-10px;`
      }
      return style
    },
    typeSonStyleActive() {
      var style = ''
      if (this.finalDatas.layout == 'left') {
        style += `border:1px solid ${this.finalDatas.colorActive};background:${this.finalDatas.colorActive}15;color:${this.finalDatas.colorActive};`
      } else {
        if (this.finalDatas.parentStyle == 'yk') {
          style += `background:${this.finalDatas.ykColor}15;color:${this.finalDatas.ykColor};`
        }
        if (this.finalDatas.parentStyle == 'fk') {
          style += `background:${this.finalDatas.fkColor}15;color:${this.finalDatas.fkColor};`
        }
        if (this.finalDatas.parentStyle == 'qp') {
          style += `background:${this.finalDatas.qpColorActive}15;color:${this.finalDatas.qpColorActive};`
        }
        if (this.finalDatas.parentStyle == 'xhx') {
          style += `background:${this.finalDatas.xhxColor}15;color:${this.finalDatas.colorActive};`
        }

      }
      if (this.finalDatas.childStyle == 'circular') {
        style += `border-radius:12px;`
      }


      return style
    },
    typeSonStyle() {
      var style = `color:${this.finalDatas.color};`
      if (this.finalDatas.layout == 'left') {
        style += `background:${this.finalDatas.backgroundColor};`
      } else {
        if (this.finalDatas.background && this.finalDatas.parentStyle != 'xhx') {
          style += `background:${this.finalDatas.backgroundColor}`
        }
      }
      if (this.finalDatas.childStyle == 'circular') {
        style += `border-radius:12px;`
      }

      return style
    },
    typeStyleActive() {
      var style = ''
      if (this.finalDatas.layout == 'left') {
        style += `background:#fff;`
      } else {
        if (this.finalDatas.menuType == 'text') {
          if (this.finalDatas.parentStyle == 'qp') {
            style += `background:${this.finalDatas.qpColorActive};`
          }
        }

      }
      style += `color:${this.finalDatas.colorActive};`

      return style

    },
    activeStaStyle() {
      var style = ''
      if (this.finalDatas.layout == 'left') {
        style += `background:${this.finalDatas.colorActive};`
      } else {
        if (this.finalDatas.parentStyle == 'xhx') {
          style += `background:${this.finalDatas.xhxColor};`
        }
        if (this.finalDatas.parentStyle == 'qp') {
          style += `border-top-color:${this.finalDatas.qpColorActive};`
        }
      }

      return style
    },
    itemWidth() {
      return (167 * (document.documentElement.clientWidth / 375))
    },

    titFontSize() {

      var titFontSize = `font-size:${this.finalDatas.titFontSize};`
      if (this.finalDatas.titColor) {
        titFontSize += `color:${this.finalDatas.titColor};`
      }

      return titFontSize
    },
    priceColor() {
      return `color:${this.finalDatas.priceColor}`
    },
    priceSize() {
      return `font-size:${this.finalDatas.priceFontSize}`
    },
    imgStyle() {
      if (this.finalDatas.goodsBorderType == 'circular') {
        if (this.finalDatas.goodsLayout != 'card') {
          return 'border-bottom-left-radius:0.213333rem;border-bottom-right-radius:0.213333rem;'
        } else {
          return ''
        }
      } else {
        return ''
      }

    },
    goodsStyle() {
      var style = ''

      if (this.finalDatas.goodsBorderType == 'circular') {
        style += 'border-radius:0.213333rem;'
      }
      if (this.finalDatas.goodsStyle == 'shadow') {
        style += `box-shadow:0px 6px 12px 0px rgba(74, 112, 196, 0.1);`
      } else {
        if (this.finalDatas.borderColor != 'transparent') {
          style += `border:2px solid ${this.finalDatas.borderColor};`
        }
      }
      if (this.finalDatas.goodsBgColor) {
        style += `background:${this.finalDatas.goodsBgColor};`
      }
      return style
    },
    labBg() {
      return `background:${this.finalDatas.goodsBgColor};`
    },
    labColor() {
      return `color:${this.finalDatas.color};`
    },
    thumbSuffix() {
      var thumbSuffix = "";
      if (this.isSquarePic == 'T') {
        thumbSuffix =
          "?imageView2/1/w/460/h/460/format/webp&x-oss-process=image/resize,m_fill,w_400,h_400";
      } else {
        if (this.finalDatas.goodsLayout == "pic") {
          thumbSuffix =
            "?imageView2/1/w/690/h/460/format/webp&x-oss-process=image/resize,m_fill,w_694,h_460";
        } else {
          thumbSuffix =
            "?imageView2/1/w/336/h/224/format/webp&x-oss-process=image/resize,m_fill,w_336,h_224";
        }
      }

      return thumbSuffix;
    },
  },
  methods: {
    findAggregateTypeGoodsTotal(cb){
      let opt = {
        hotelGroupCode:config.hotelGroupCode,
        typeIds:''
      }
      let typeIdArr = []
      this.finalDatas.groupList.forEach(item => {
        typeIdArr.push(item.id)
      })
      opt.typeIds = typeIdArr.join(',')
      api.findAggregateTypeGoodsTotal(opt).then((res) => {
        if(res.result == 0){
          res.retVal.forEach(type => {
            this.finalDatas.groupList.forEach(item => {
              if(type.id == item.id){
                if(type.goodsTotal>item.number){
                  this.$set(item,'goodsTotal',item.number)
                }else{
                  this.$set(item,'goodsTotal',type.goodsTotal)
                }
              }
            })
          })
        }else{
          jAlert3(res.msg)
        }
        cb&&cb();
      })
    },
    scrollToDiv(sectionId) {
      this.isScroll = true

      this.observer.disconnect()
      document.getElementById('id'+sectionId).scrollIntoView({ behavior: 'smooth' });
      setTimeout(() => {
        this.$nextTick(() => {
          this.finalDatas.groupList.forEach((item, index) => {
            if (item.id == sectionId) {
              this.$set(item,'active',true)
            } else {
              this.$set(item,'active',false)
            }
          })
          
          this.isScroll = false
        })
        
      }, 300);
      setTimeout(() => {
        this.setupIntersectionObserver()
      }, 1000);
     
      
    },
    // infinite() {
    //   this.getDetailList()
    // },
    getDetailList(id) {
      let pass = true
      var opt = {
        typeId: id,
        hotelGroupCode: config.hotelGroupCode,
        hotelCode: config.hotelCode,
        channel: config.channel,
        appid: config.appid
      }

      if (this.user && this.user.memberId) {
        this.getCurrentCard();
        var chuzhiIndex = getStorage("cardIndex") || 0;
        opt.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
        opt.cardType = this.user.cardListDto[chuzhiIndex].cardType;
      }
      this.finalDatas.groupList.forEach((item, index) => {
        if(item.id == id){
          if(item.request=='T'){
            pass = 'F'
          }else{
            this.$set(item,'request','T')
          }
        }
      })
      if(pass=='F'){
        return;
      }
      api.detailList(opt).then((res) => {
        if (res.result == 0) {
          if (res.retVal.length) {
            res.retVal.forEach(item => {
              if (item.type == 'goods') {
                this.showSold = 'T'
              }
              if (!item.credit) {
                item.credit = 0
              }
              if (item.memberPrice) {
                item.price = item.memberPrice
              }
              if (item.skuFlag) {
                if (item.skuFlag == 'T') {
                  item.skuFlag = true
                } else {
                  item.skuFlag = false
                }
              }
              if (item.type == 'scenic' || item.type == 'ticket' || item.type == 'diy') {
                var pictures = item.logo.split(';')
                item.logo = pictures[0]
              }
              if (item.goodsName) {
                item.name = item.goodsName
              }
              if (item.type !== 'goods') {
                item.stock = 999
              }
              if (item.extraInfo && item.extraInfo != '') {
                var extraInfo = JSON.parse(item.extraInfo)
                extraInfo.discountList.forEach(discount => {
                  if (extraInfo.activityType == 'fullReduction') {
                    if (extraInfo.discountType == 'quota') {
                      discount.discountTxt = `满${discount.fullNum}元减${discount.reduceNum}元`
                    }
                    if (extraInfo.discountType == 'number') {
                      discount.discountTxt = `满${discount.fullNum}件减${discount.reduceNum}元`
                    }
                    if (extraInfo.discountType == 'circulate') {
                      discount.discountTxt = `每满${discount.fullNum}元减${discount.reduceNum}元`
                    }
                  }
                  if (extraInfo.activityType == 'fullDiscount') {
                    discount.discountTxt = `满${discount.fullNum}件${discount.reduceNum}折`
                  }
                  if (extraInfo.activityType == 'fullDelivery') {
                    if (extraInfo.discountType == 'coupons') {
                      var couponsArr = []
                      extraInfo.couponsArr.forEach(item => {
                        couponsArr.push(item.descript)
                      })
                      discount.discountTxt = `满${discount.fullNum}元赠送${couponsArr.join(',')}`
                    }
                  }

                })
                item.extraInfo = extraInfo

              }
              if (item.vrType == 'retail') {
                item.stock = 999
              }
              if (item.stock <= 0) {
                item.isHalt = 'T'
              }
            })
            

          }
          this.finalDatas.groupList.forEach((item, index) => {
            if(item.id == id){
              this.$set(item, 'goodsList', res.retVal)
              this.$set(item,'isRequest',true)
            }
          })
        
          this.loading = false

        } else {
          jAlert3(res.msg);
        }
        this.canRequest = true
      });
    },
    onRefresh() {
      var index = 0
      this.finalDatas.groupList.forEach((item, i) => {
        console.log(item)
        if (item.active) {
          index = i
        }
      })
      if (this.finalDatas.groupList[index - 1]) {
        this.chooseType(this.finalDatas.groupList[index - 1].id, 'T')
      }
      this.$refs.scrollLoad.finishRefresh()
    },
    onLoad() {
      var index = 0
      this.finalDatas.groupList.forEach((item, i) => {
        console.log(item)
        if (item.active) {
          index = i
        }
      })
      if (this.finalDatas.groupList[index + 1]) {
        this.chooseType(this.finalDatas.groupList[index + 1].id, 'T')
      }

    },
    beforeChange(index) {
      if (!this.canRequest) {
        return false;
      }
      return new Promise((resolve) => {
        // 在 resolve 函数中返回 true 或 false
        resolve(true);
      });
    },
    batchQueryShopConfig() {
      api.batchQueryShopConfig({
        hotelGroupCode: config.hotelGroupCode,
        hotelCode: config.hotelCode,
        configItem: 'goods_type_price_condition,closeTypeCondition'
      }).then(res => {
        this.closeTypeCondition = 'F';
        res.retVal.forEach(item => {
          if (item.configItem == 'goods_type_price_condition') {

            if (item.itemValue == 'T') {
              this.goods_type_price_condition = 'T';
            }
          }
          if (item.configItem == 'closeTypeCondition') {
            if (item.itemValue == 'T') {
              this.closeTypeCondition = 'T';
            }
          }

        })

      })
    },
    scrollTab(val) {
      this.isFixed = val.isFixed

    },
    soldSort() {
      this.priceMode = ''
      if (!this.soldMode || this.soldMode == 'desc') {
        this.parentGoodsList.forEach(goodsList => {
          goodsList.goods.sort((a, b) => a.sold - b.sold);
        })
        if (this.goodsList.length > 0) {
          this.goodsList.sort((a, b) => a.sold - b.sold);
        }
        this.soldMode = 'acs'
      } else {
        this.parentGoodsList.forEach(goodsList => {
          goodsList.goods.sort((a, b) => b.sold - a.sold);
        })
        if (this.goodsList.length > 0) {
          this.goodsList.sort((a, b) => b.sold - a.sold);
        }
        this.soldMode = 'desc'
      }
    },
    priceSort() {
      this.soldMode = ''
      if (!this.priceMode || this.priceMode == 'desc') {
        this.parentGoodsList.forEach(goodsList => {
          goodsList.goods.sort((a, b) => {
            if (a.price !== b.price) {
              return a.price - b.price;
            } else {
              return a.credit - b.credit;
            }
          }
          );
        })
        if (this.goodsList.length > 0) {
          this.goodsList.sort((a, b) => {
            if (a.price !== b.price) {
              return a.price - b.price;
            } else {
              return a.credit - b.credit;
            }
          }
          );

        }

        this.priceMode = 'acs'
      } else {
        this.parentGoodsList.forEach(goodsList => {
          goodsList.goods.sort((a, b) => {
            if (a.price !== b.price) {
              return b.price - a.price;
            } else {
              return b.credit - a.credit;
            }
          })


        })
        if (this.goodsList.length > 0) {
          this.goodsList.sort((a, b) => {
            if (a.price !== b.price) {
              return b.price - a.price;
            } else {
              return b.credit - a.credit;
            }
          })

        }

        this.priceMode = 'desc'
      }

    },
    goHotelList() {
      window.location.href = `/wechat/?/#/hotelListNew?otaChannel=WECHAT`;
    },
    goGoods(item) {
      if (item.type == 'goods') {
        this.$router.push({
          path: "/goodsDetail",
          query: {
            id: item.goodsId
          },
        });
      } else {
        var url = ''
        if (item.type == 'diy') {
          if (this.customPack == '5') {
            url = '/wechat/?/#/hdCombinationInfoDesc?otaChannel=WECHAT&typeCode=PACK&productCode=' + item.productCode + '&packCode=' + item.goodsId + '&price=' + item.price + '&customPack=5';
          } else {
            url = '/wechat/?/#/combinationFree?otaChannel=WECHAT&typeCode=PACK&productCode=' + item.productCode + '&packCode=' + item.goodsId + '&price=' + item.price;
          }

        }
        if (item.type == 'ticket') {
          url = '/wechat/?/#/ticketInfo?productCode=' + item.productCode + '&scenicSpotCode=' + item.scenicSpotCode;
        }
        if (item.type == 'pack') {
          url = '/wechat/?/#/combinationInfoDesc?otaChannel=WECHAT&productCode=' + item.goodsId + '&price=' + item.memberPrice;
        }
        if (item.type == 'room') {
          if (item.hotelCode == 0) {
            url = `/wechat/?/#/hotelListNew?otaChannel=WECHAT`;
          } else {
            url = `/wechat/?/#/hotel?hotelCode=${item.hotelCode}&hotelGroupCode=${item.hotelGroupCode}`;
          }
        }
        if (item.type == 'scenic') {
          url = `/wechat/?/#/ticketDetail?code=${item.goodsId}`
        }
        var distributor = ''
        if (this.$route.query.distributorId) {
          distributor = `&shareOpenid=${this.$route.query.distributorOpenIdDis}&distributorId=${this.$route.query.distributorId}&distributorOpenId=${this.$route.query.distributorOpenIdDis}`
        } else if (this.$route.query.distributorOpenIdDis) {
          distributor = `&shareOpenid=${this.$route.query.distributorOpenIdDis}`
        }
        window.location.href = `${url}${distributor}`
      }

    },
    isShowSku(goods) {
      var item = goods;
      if (!item.id) {
        item.id = item.goodsId
      }
      item.shopGoodsConfig = goods.goodsConfig;
      if (this.goodsId != item.id) {
        this.curInfo = {
          currentStock: item.stock,
          currentPrice: item.price,
          currentCredit: item.credit,
        };
      }
      this.goodsId = item.id;
      this.goodsDetail = item;
      this.$refs.layerSku.isShowSku();
    },
    listAllGoodsDetailByParent(typeId, type) {

      var opt = {
        typeId: typeId,
        hotelGroupCode: config.hotelGroupCode,
        hotelCode: config.hotelCode,
        channel: config.channel,
        appid: config.appid
      }
      if (this.user && this.user.memberId) {
        this.getCurrentCard();
        var chuzhiIndex = getStorage("cardIndex") || 0;
        opt.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
        opt.cardType = this.user.cardListDto[chuzhiIndex].cardType;
      }
      this.parentGoodsList = []
      api.listAllGoodsDetailByParent(opt).then((res) => {
        if (res.result == 0) {

          if (type) {
            this.parentTypeList = type
          }
          this.showSold = 'F'
          var children = res.retVal
          for (let i = 0; i < res.retVal.length; i++) {
            let goodsList = res.retVal[i];

            goodsList.goods.forEach(item => {
              if (item.type == 'goods') {
                this.showSold = 'T'
                goodsList.showSold = 'T'
              }
              if (!item.credit) {
                item.credit = 0
              }
              if (item.memberPrice) {
                item.price = item.memberPrice
              }
              if (item.type == 'scenic' || item.type == 'ticket' || item.type == 'diy') {
                var pictures = item.logo.split(';')
                item.logo = pictures[0]
              }
              if (item.skuFlag) {
                if (item.skuFlag == 'T') {
                  item.skuFlag = true
                } else {
                  item.skuFlag = false
                }
              }
              if (item.goodsName) {
                item.name = item.goodsName
              }
              if (item.type !== 'goods') {
                item.stock = 999
              }
              if (item.extraInfo && item.extraInfo != '') {
                var extraInfo = JSON.parse(item.extraInfo)
                extraInfo.discountList.forEach(discount => {
                  if (extraInfo.activityType == 'fullReduction') {
                    if (extraInfo.discountType == 'quota') {
                      discount.discountTxt = `满${discount.fullNum}元减${discount.reduceNum}元`
                    }
                    if (extraInfo.discountType == 'number') {
                      discount.discountTxt = `满${discount.fullNum}件减${discount.reduceNum}元`
                    }
                    if (extraInfo.discountType == 'circulate') {
                      discount.discountTxt = `每满${discount.fullNum}元减${discount.reduceNum}元`
                    }
                  }
                  if (extraInfo.activityType == 'fullDiscount') {
                    discount.discountTxt = `满${discount.fullNum}件${discount.reduceNum}折`
                  }
                  if (extraInfo.activityType == 'fullDelivery') {
                    if (extraInfo.discountType == 'coupons') {
                      var couponsArr = []
                      extraInfo.couponsArr.forEach(item => {
                        couponsArr.push(item.descript)
                      })
                      discount.discountTxt = `满${discount.fullNum}元赠送${couponsArr.join(',')}`
                    }
                  }

                })
                item.extraInfo = extraInfo

              }
              if (item.vrType == 'retail') {
                item.stock = 999
              }
              if (item.stock <= 0) {
                item.isHalt = 'T'
              }
            })
            if (!goodsList.goods || goodsList.goods.length == 0) {
              res.retVal.splice(i, 1)
              i--
            }
          }

          if (children.length > 0) {
            children[0].active = true
            this.childType = children[0]
          }
          if (this.parentTypeList.number === '') {
            this.parentTypeList.number = '999'
          }
          this.parentTypeList.children = children
          this.parentGoodsList = res.retVal
          this.priceMode = ''
          this.soldMode = ''
          if (this.goods_type_price_condition == 'T') {
            this.priceSort()
          }

        } else {
          jAlert3(res.msg);
        }
        this.isLoading = false
        this.canRequest = true
      })
    },
    detailList(typeId) {

      var opt = {
        typeId: typeId,
        hotelGroupCode: config.hotelGroupCode,
        hotelCode: config.hotelCode,
        channel: config.channel,
        appid: config.appid
      }
      if (this.user && this.user.memberId) {
        this.getCurrentCard();
        var chuzhiIndex = getStorage("cardIndex") || 0;
        opt.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
        opt.cardType = this.user.cardListDto[chuzhiIndex].cardType;
      }

      api.detailList(opt).then((res) => {
        this.goodsList = []
        if (res.result == 0) {
          this.showSold = 'F'
          if (res.retVal.length) {
            res.retVal.forEach(item => {
              if (item.type == 'goods') {
                this.showSold = 'T'
              }
              if (!item.credit) {
                item.credit = 0
              }
              if (item.memberPrice) {
                item.price = item.memberPrice
              }
              if (item.skuFlag) {
                if (item.skuFlag == 'T') {
                  item.skuFlag = true
                } else {
                  item.skuFlag = false
                }
              }
              if (item.type == 'scenic' || item.type == 'ticket' || item.type == 'diy') {
                var pictures = item.logo.split(';')
                item.logo = pictures[0]
              }
              if (item.goodsName) {
                item.name = item.goodsName
              }
              if (item.type !== 'goods') {
                item.stock = 999
              }
              if (item.extraInfo && item.extraInfo != '') {
                var extraInfo = JSON.parse(item.extraInfo)
                extraInfo.discountList.forEach(discount => {
                  if (extraInfo.activityType == 'fullReduction') {
                    if (extraInfo.discountType == 'quota') {
                      discount.discountTxt = `满${discount.fullNum}元减${discount.reduceNum}元`
                    }
                    if (extraInfo.discountType == 'number') {
                      discount.discountTxt = `满${discount.fullNum}件减${discount.reduceNum}元`
                    }
                    if (extraInfo.discountType == 'circulate') {
                      discount.discountTxt = `每满${discount.fullNum}元减${discount.reduceNum}元`
                    }
                  }
                  if (extraInfo.activityType == 'fullDiscount') {
                    discount.discountTxt = `满${discount.fullNum}件${discount.reduceNum}折`
                  }
                  if (extraInfo.activityType == 'fullDelivery') {
                    if (extraInfo.discountType == 'coupons') {
                      var couponsArr = []
                      extraInfo.couponsArr.forEach(item => {
                        couponsArr.push(item.descript)
                      })
                      discount.discountTxt = `满${discount.fullNum}元赠送${couponsArr.join(',')}`
                    }
                  }

                })
                item.extraInfo = extraInfo

              }
              if (item.vrType == 'retail') {
                item.stock = 999
              }
              if (item.stock <= 0) {
                item.isHalt = 'T'
              }
            })
            this.goodsList = res.retVal
          }
          this.priceMode = ''
          this.soldMode = ''
          if (this.goods_type_price_condition == 'T') {
            this.priceSort()
          }
          console.log(this.goodsList)
        } else {
          jAlert3(res.msg);
        }
        this.isLoading = false
        this.canRequest = true
      });

    },
    chooseTypeNew(name) {
      if (document.querySelector("#id" + name) != null) {
        this.scrollToDiv(name)
      } 
    },
    chooseType(name, parent) {
      if(this.isOnlyOne){
        this.chooseTypeNew(name)
        return;
      }
      if (!this.canRequest) {
        return;
      }
      this.canRequest = false
      var type = ''
      this.finalDatas.groupList.forEach(item => {
        if (item.id == name) {
          this.$set(item, 'active', true)
          type = item
        } else {
          this.$set(item, 'active', false)
        }

      })
      if (type.name) {
        this.$emit('chooseType', type.name)
      }
      this.parentTypeList = []
      this.initChildType = false
      this.$nextTick(() => {
        this.initChildType = true
      })
      this.isLoading = true
      this.updateHashParameter(type.name)
      if (type.children && type.children.length > 0) {
        if (parent == 'T') {
          this.listAllGoodsDetailByParent(name, type)
          return;
        }
        this.chooseChildType(type.children[0].id)
      } else {
        this.parentTypeList = type
        if (this.parentTypeList.number === '') {
          this.parentTypeList.number = '999'
        }
        this.childType = {}
        if (this.timer == null) {
          this.timer = setTimeout(() => {
            this.detailList(type.id)
          }, 200);
        } else {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {

            this.detailList(type.id)
          }, 200);
        }

      }

    },
    chooseChildType(name) {
      if (this.stop) {
        return
      }
      var type = ''
      this.parentTypeList.children.forEach(item => {
        if (item.id == name) {

          this.$set(item, 'active', true)
          type = item
        } else {
          this.$set(item, 'active', false)
        }

      })

      this.childType = type


    },
    childTypeClick(name) {
      this.stop = true
      var type = ''
      this.parentTypeList.children.forEach(item => {
        if (item.id == name) {

          this.$set(item, 'active', true)
          type = item
        } else {
          this.$set(item, 'active', false)
        }

      })

      this.childType = type

      setTimeout(() => {
        this.stop = false
      }, 500);

    },
    setupIntersectionObserver() {
      const options = {
        root: null, // 使用视口作为根
        rootMargin: '0px',
        threshold: 0.1 // 当10%的目标元素可见时触发回调
      };

      this.observer = new IntersectionObserver(this.handleIntersect, options);
      // 观察每个节点
      this.finalDatas.groupList.forEach(item => {
        this.observer.observe(document.getElementById('id'+item.id));
      })
     
    },
    handleIntersect(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.getDetailList(entry.target.id.replace('id',''))
          console.log(`${entry.target.id} 已进入视口`);
        } 
      });
    },
   
    scrollFixed() {
      if (
        this.$refs.leftType.getBoundingClientRect().top <= 0
      ) {
        this.fixed = true;
      } else {
        this.fixed = false;
      }
      if( this.isScroll){
        return
      }
      if(this.isOnlyOne){
        const sections = document.querySelectorAll('.type_right');
        let index = 0;
        this.finalDatas.groupList.forEach(item => {
          this.$set(item, 'active', false)
        })
        sections.forEach((section, i) => {
          const rect = section.getBoundingClientRect();
          if (rect.top < 1) {
            index = i;
          }
        });
        
        this.$set(this.finalDatas.groupList[index], 'active', true)
      }
     

    },
    updateHashParameter(newValue) {
      const currentQuery = { ...this.$route.query };
      currentQuery.typeName = encodeURIComponent(newValue);
      currentQuery.savedPosition = true;
      this.$router.replace({ query: currentQuery });
    },
  },
  created() {
    config = getStorage("config");
  },
  destroyed() {

    window.removeEventListener("scroll", this.scrollFixed);
  },
  mounted() {
    this.batchQueryShopConfig()

    this.finalDatas = JSON.parse(JSON.stringify(this.datas));
    if (this.finalDatas.parentStyle == 'xhx') {
      this.style.type = 'line'
    } else {
      this.style.type = 'card'
    }

    if (this.finalDatas.menuType == 'pic') {
      this.style.inactiveColor = this.finalDatas.color
      this.style.activeColor = this.finalDatas.colorActive
      this.style.childInactiveColor = this.finalDatas.color
    }
    if (this.finalDatas.layout == 'left') {
      this.style.childColor = this.finalDatas.colorActive + '15'
      this.style.childActiveColor = this.finalDatas.colorActive
      this.style.childInactiveColor = this.finalDatas.color
      this.finalDatas.groupList.forEach(type => {
        this.$set(type,'active',false)
        if (type.children && type.children.length > 0) {
          this.isOnlyOne = false
        }
      })

    }else{
      this.isOnlyOne = false
    }
    if (this.finalDatas.menuType == 'text' && this.finalDatas.layout == 'top') {
      this.style.inactiveColor = this.finalDatas.color
      this.style.activeColor = this.finalDatas.colorActive
      this.style.childInactiveColor = this.finalDatas.color

      if (this.finalDatas.parentStyle == 'yk') {
        this.style.color = this.finalDatas.ykColor
        this.style.childColor = this.finalDatas.ykColor + '15'
        this.style.childActiveColor = this.finalDatas.ykColor

      }
      if (this.finalDatas.parentStyle == 'fk') {
        this.style.color = this.finalDatas.fkColor
        this.style.childColor = this.finalDatas.fkColor + '15'
        this.style.childActiveColor = this.finalDatas.fkColor
      }
      if (this.finalDatas.parentStyle == 'qp') {
        this.style.color = this.finalDatas.qpColorActive
        this.style.childColor = this.finalDatas.qpColorActive + '15'
        this.style.childActiveColor = this.finalDatas.qpColorActive
        this.$nextTick(() => {
          var tabs = document.getElementsByClassName('van-tab')
          tabs.forEach(item => {
            item.innerHTML = `${item.innerHTML}<i style="border-top-color:${this.style.color}"></i>`
          })

        })
      }
      if (this.finalDatas.parentStyle == 'xhx') {
        this.style.color = this.finalDatas.xhxColor
        this.style.childColor = this.finalDatas.xhxColor + '15'
        this.style.childActiveColor = this.finalDatas.xhxColor
        // this.style.color = this.finalDatas.colorActive
        //  style += `background:${this.finalDatas.xhxColor}15;color:${this.finalDatas.colorActive};`

      }
    }
    var typeId = ''

    if (this.finalDatas.layout == 'left') {
      window.addEventListener("scroll", this.scrollFixed);
    }
    if (this.finalDatas.groupList && this.finalDatas.groupList.length > 0) {

      var defaultIndex = 0;
      if (this.$route.query.typeName) {
        this.finalDatas.groupList.forEach((item, i) => {
          if (item.name == decodeURIComponent(this.$route.query.typeName)) {
            defaultIndex = i
          }
        })
      }
      this.$nextTick(() => {
        if (this.finalDatas.layout == 'top') {
          this.$refs.tabs.onClick(this.finalDatas.groupList[defaultIndex].id, defaultIndex)
        } else {
          if (this.isOnlyOne) {
            this.isLoading = true
            this.findAggregateTypeGoodsTotal(()=>{
              this.isLoading = false
             this.$nextTick(()=>{
              this.getDetailList(this.finalDatas.groupList[defaultIndex].id)
              this.setupIntersectionObserver()
             })
            })
           
          
            this.$set(this.finalDatas.groupList[defaultIndex], 'active', true)
          } else {
            this.chooseType(this.finalDatas.groupList[defaultIndex].id, 'T')
          }

        }
      })
      // this.chooseType(this.finalDatas.groupList[defaultIndex].id, 'T')
    }
    // this.finalDatas.groupList.forEach((item, i) => {
    //     if (i == '0') {
    //         item.active = true
    //         typeId = item.id
    //         this.parentTypeList = item
    //         if (item.children && item.children.length > 0) {
    //             item.children[0].active = true
    //             typeId = item.children[0].id
    //             this.childType = item.children[0]
    //         }
    //         this.detailList(typeId)
    //     }
    // })

  },
  components: {
    layerSku,
    goodsListBig,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    ScrollLoad
  }
};
</script>

<style lang="less" scoped>
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");

.typeList_ui {
  position: relative;

  ::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }
  .type_right_warp {
    width: calc(100% - 2.266667rem);
    .loading-img {
      width: 100%;
      text-align: center;
      margin-top: 50%;
      img {
        width: 100px;
        height: 100px;
      }
    }
  }
  /deep/.type_right {
    position: relative;
    .van-sticky--fixed {
      width: calc(100% - 2.266667rem);
      background: #fff;
      left: 2.266667rem;
    }
    .van-tabs__content {
      position: relative;
    }
    .sticky-nav {
      display: flex;
      justify-content: space-between;
      position: absolute;
      align-items: center;
      top: -15px;
      left: 0;
      background: #fff;
      z-index: 19;
      width: 100%;
      padding: 10px;
      &.fixed-nav {
        position: fixed;
        top: 40px;
        left: 2.266667rem;
        width: calc(100% - 2.266667rem);
      }
      &.relative-nav {
        position: relative;
        top: 0;
      }
      &::after {
        content: "";
        height: 1px;
        width: 100%;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        transform: scaleY(0.5);
        background: #dddddd;
      }
      .sort-warp {
        display: flex;
        align-items: center;
      }
      .sort-item {
        margin-left: 20px;
        display: flex;
        align-items: center;
        font-size: 11px;
        color: #666666;

        i {
          margin-left: 5px;
          font-size: 9px;
          transition: all 0.3s;
        }
        &.acs {
          color: @color-theme;
          i {
            transform: rotate(180deg);
          }
        }
        &.desc {
          color: @color-theme;
        }
      }
      .type_name {
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 600;
      }
    }
    .van-tab {
      flex: none;
      padding: 0 12px;
      box-sizing: border-box !important;
    }
    .van-tabs__wrap {
      padding-top: 10px;
    }

    .childType {
      .van-tabs__nav {
        background: none;
      }

      .van-tab {
        font-size: 12px;
        height: 25px;
        border-radius: 15px;
        border-right: 0;
        margin: 0 3px;
        box-sizing: content-box;
      }

      &.normal {
        .van-tab {
          border-radius: 2px;
        }
      }

      .van-tabs__nav--card {
        border: 0 !important;
      }
    }
  }

  /deep/.type_top_mode {
    .sticky-nav {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #fff;
      width: 100%;
      padding: 10px 15px;
      font-size: 13px;
      &::after {
        content: "";
        height: 1px;
        width: 100%;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        transform: scaleY(0.5);
        background: #dddddd;
      }
      .sort-warp {
        display: flex;
        align-items: center;
      }
      .sort-item {
        margin-left: 50px;
        display: flex;
        align-items: center;
        font-size: 11px;
        color: #666666;

        i {
          margin-left: 5px;
          font-size: 8px;
          transition: all 0.3s;
        }
        &.acs {
          color: @color-theme;
          i {
            transform: rotate(180deg);
          }
        }
        &.desc {
          color: @color-theme;
        }
      }
      .type_name {
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 600;
      }
    }
    .van-tabs__nav {
      margin: 0;
      padding: 0.266667rem 0.426667rem;
    }

    .typeBox {
      z-index: 10px;

      .van-tabs__nav {
        background: none;
      }

      .van-tab {
        margin: 0 3px;
      }
    }
    .picType {
      height: 68px;
      .van-tabs__nav,
      .van-tabs__wrap {
        height: 68px;
      }
      .van-tab {
        height: 58px;
        padding-top: 20px;
        margin: 0 3px;
      }
    }

    .goodsList {
      padding-bottom: 0.266667rem;
    }

    .van-tabs__wrap {
      height: 48px;
    }

    .van-tabs__nav {
      height: 48px;
    }

    .childType {
      .van-tabs__wrap {
        height: 45px;
      }

      .van-tabs__nav {
        background: none;
        height: 45px;
      }

      .van-tab {
        font-size: 12px;
        height: 25px;
        border-radius: 15px;
        border-right: 0;
        margin: 0 3px;
      }

      &.normal {
        .van-tab {
          border-radius: 2px;
        }
      }

      .van-tabs__nav--card {
        border: 0 !important;
      }
    }

    .xhx {
      .van-tabs__wrap {
        height: 53px;
      }

      .van-tabs__nav {
        height: 38px;
      }
    }

    .yk {
      .van-tabs__nav--card {
        border: 0 !important;
      }

      .van-tab {
        border-radius: 15px;
        border-right: 0;
      }
    }

    .fk {
      .van-tabs__nav--card {
        border: 0 !important;
      }

      .van-tab {
        border-radius: 2px;
        border-right: 0;
      }
    }

    .van-tab {
      height: 30px;
    }

    .qp {
      .van-tabs__wrap {
        height: 48px;
      }

      .van-tabs__nav--card {
        border: 0 !important;
        border-radius: 0 !important;
      }

      .van-tabs__nav {
        height: 48px;
        z-index: 9;
      }

      .van-tab {
        border-radius: 2px;
        border-right: 0;
        height: 30px;

        i {
          display: none;
        }

        &.van-tab--active {
          i {
            display: block;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: -6px;
            width: 0;
            height: 0;
            border-top: 6px solid;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
          }
        }
      }
    }
  }

  .type_left_mode {
    position: relative;
    display: flex;
    min-height: 100vh;

    .type-box_warp {
      width: 2.266667rem;

      .type_item {
        .type_item_desc {
          padding: 0 10px;
          white-space: normal;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          line-height: 1.4;
        }
      }
    }

    .type-box {
      width: 2.266667rem;
      overflow-y: scroll;
      height: 100vh;

      &.fixed {
        position: fixed;
        top: 0;
        left: 0;
      }

      .type_item {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 1.333333rem;
        font-size: 12px;
        color: #333333;

        &.active {
          font-family: PingFangSC-Semibold;
          font-size: 14px;
          font-weight: bold;

          .activeSta {
            height: 0.533333rem;
            position: absolute;
            left: 0;
            top: 50%;
            width: 4px;
            transform: translateY(-50%);
            border-radius: 0px 2px 2px 0px;
          }
        }
      }
    }

    .type_right {
      width: 100%;

      .type_bar_son {
        .type_item {
          font-size: 12px;
          border-radius: 2px;
          height: 0.666667rem;
        }
      }
    }

    .type_bar_son {
      padding: 0.133333rem 0.293333rem;
      background: #fff;
      display: flex;

      &.type_bar_scroll {
        overflow-x: auto;
        padding-bottom: 6px;

        .type_item {
          flex: 1 0 auto;
        }

        &::after {
          content: "";
          width: 0.293333rem;
          display: flex;
          flex: 1 0 auto;
        }
      }

      .type_item {
        position: relative;

        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 0.08rem;
        font-size: 14px;
        color: #111111;
        // flex: 1;
        padding: 0 0.4rem;
        height: 0.8rem;

        .type_item_desc {
          white-space: normal;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }
      }
    }
  }

  .hotel {
    margin: 0.266667rem 0.266667rem 0 0.266667rem;
    padding: 0.266667rem 0.533333rem;
    background: #f7f7f7;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1.4;

    .hotel_date {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .date {
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #333333;
        text-align: center;
        font-weight: 600;
      }

      .date_desc {
        margin-top: 0.053333rem;
        font-size: 10px;
        color: #333333;
      }
    }

    .number {
      border: 0.5px solid rgba(51, 51, 51, 1);
      border-radius: 9px;
      font-size: 11px;
      color: #333333;
      padding: 0 0.213333rem;
    }
  }

  .goodsList {
    margin-top: 0.266667rem;
    // padding-top: 0.4rem;

    .goods-list-box {
      padding: 0 0.4rem;
      margin-top: -0.266667rem;
      &.mini-box {
        margin-top: 0.133333rem;
        .goods-list-container {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
        }

        .box {
          width: 3.35rem;
          .img-box {
            height: 2.23rem;
            &.img-box-square {
              height: 3.35rem;
            }
          }
          .goods-content {
            .goods-name {
              font-size: 12px;
              line-height: 18px;
              height: 36px;
            }
            .price-box {
              padding-right: 0;
              .price {
                font-size: 12px;
              }
            }
          }
        }
      }
      &.grid {
        .goods-list-container {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
        }
      }

      &.waterfall {
        .box {
          .img-box {
            height: auto;

            img {
              width: 100%;
              height: auto;
            }
          }

          .goods-content {
            .goods-name {
              max-height: 1.066667rem;
              height: auto;
            }

            .goods-desc {
              height: auto;
              max-height: 0.586667rem;
            }
          }
        }
      }

      &.pic {
        .box {
          width: 100%;

          .img-box {
            height: 6.133333rem;

            &.img-box-square {
              height: 9.2rem;
            }

            img {
              width: 100%;
              height: 100%;
            }
          }

          .goods-content {
            .goods-name {
              font-size: 18px;
              color: #333333;
              line-height: 0.666667rem;
              height: 1.333333rem;
            }

            .price {
              justify-content: flex-start;
            }
          }
        }
      }

      &.mult {
        width: 100%;
        white-space: nowrap;
        display: flex;
        overflow-y: hidden;
        overflow-x: scroll;

        .goods-list-container {
          .box {
            width: 4rem;
            margin-right: 0.266667rem;

            .img-box {
              height: 2.666667rem;

              &.img-box-square {
                height: 4rem;
              }
            }
          }
        }
      }

      &.card {
        .box {
          display: flex;
          justify-content: space-between;
          width: 100%;

          .img-box {
            width: 4.346667rem;
            height: 2.8978rem;

            &.img-box-square {
              height: 2.8978rem;
              width: 2.8978rem;
            }

            .bg {
              display: none;
            }

            .bg2 {
              display: block;
            }
          }
        }

        .goods-content {
          flex: 1;
          text-align: left;

          .goods-name {
            font-size: 14px;
            color: #333333;
            -webkit-line-clamp: 2;
            line-height: 0.533333rem;
            height: 1.066666rem;
          }

          .price {
            justify-content: flex-start;
          }
        }
      }

      .box {
        width: 4.453333rem;
        background: #fff;
        margin-top: 0.266667rem;
        display: inline-block;
        box-sizing: border-box;
        position: relative;
        overflow: hidden;

        .img-box {
          width: 100%;
          overflow: hidden;
          height: 2.96rem;
          position: relative;
          box-sizing: border-box;

          &.img-box-square {
            height: 4.453333rem;
          }

          .hotelName {
            position: absolute;
            bottom: 0;
            left: 50%;
            width: 86%;
            margin-left: -43%;
            height: 0.47988rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            b {
              position: absolute;
              width: 100%;
              height: 0.47988rem;
              z-index: 2;
              font-size: 10px;
              color: #fff;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              white-space: normal;
              line-height: 0.47988rem;
              text-align: center;
              padding: 0 0.266667rem;
            }

            &:after {
              content: "";
              position: absolute;
              bottom: 0;
              z-index: 1;
              left: 50%;
              margin-left: -41.5%;
              width: 83%;
              background: @color-theme;
              opacity: 0.6;
              height: 0.47988rem;
              box-sizing: border-box;
              border-radius: 0.21328rem 0.21328rem 0 0;
              transform: perspective(0.2666rem) scale(1.1, 1.3) rotateX(5deg);
            }
          }

          .img {
            width: 100%;
            height: 100%;
          }

          .bg {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
          }

          .label {
            position: absolute;
            top: 0;
            left: 0;
            height: 0.64rem;
            font-size: 12px;
            color: #ffffff;
            padding: 0 0.266667rem;
            line-height: 0.64rem;
            text-align: center;
            z-index: 2;

            .labelBg {
              content: "";
              position: absolute;
              left: 0;
              top: 0;
              z-index: -1;
              width: 100%;
              height: 100%;
              background: #df4747;
              opacity: 0.6;
              border-radius: 0 0.213333rem 0.213333rem 0px;
            }
          }
        }

        .goods-content {
          padding: 0 0.266667rem 0.293333rem 0.266667rem;

          .goods-name {
            margin-top: 0.133333rem;
            font-size: 14px;
            line-height: 0.533333rem;
            height: 1.066667rem;
            color: #333333;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            white-space: normal;
            word-break: break-all;
          }

          .goods-desc {
            line-height: 0.586667rem;
            height: 0.586667rem;
            font-size: 12px;
            color: #999999;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            white-space: normal;
            word-break: break-all;
          }

          .goods-discount {
            height: 19px;
            overflow: hidden;

            .goods-discount-item {
              border-radius: 2px;
              color: @color-price;
              font-size: 10px;
              margin-top: 5px;
              border: 1px solid @color-price;
              display: inline-block;
              padding: 0 2px;
              line-height: 14px;
              height: 14px;
              white-space: nowrap;
              margin-right: 0.133333rem;
            }
          }

          .price-box {
            display: flex;
            color: #e55141;
            padding-right: 0.6rem;
            justify-content: flex-start;

            .price {
              font-size: 12px;
              display: inline-block;
              align-items: center;
              margin-top: 0.133333rem;
              font-family: @price-font-family;

              .cur-price {
                display: inline-block;
                font-size: 0;
              }

              .qi {
                display: inline-block;
              }

              span {
                display: inline-block;

                i {
                  display: inline-block;
                  text-decoration: none;
                  font-size: 12px;
                }

                b {
                  display: inline-block;
                  text-decoration: none;
                  font-size: 25px;
                }
              }

              span.proposedPrice {
                line-height: 16px;
                text-decoration: line-through;
                color: #999999;
                font-size: 12px;
                font-family: PingFangSC-Regular;
              }

              .credit {
                display: inline-block;
                font-style: normal;
                font-size: 10px;
                line-height: 16px;

                em,
                b {
                  display: inline-block;
                }

                span {
                  font-size: 14px;
                  display: inline-block;
                }
              }

              .free {
                b {
                  font-size: 18px;
                }
              }
            }
          }

          .add-shopCar {
            position: absolute;
            right: 0.266667rem;
            text-align: center;
            font-size: 24px;
            border-radius: 50%;
            color: #fff;
            height: 0.533333rem;
            width: 0.533333rem;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0px 4px 8px 0px rgba(74, 112, 196, 0.1);
            background: #fff;

            i {
              color: @color-theme;
              font-size: 8px;
            }
          }
        }

        .no-stock {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(255, 255, 255, 0.8);
          z-index: 8;

          img {
            position: absolute;
            left: 50%;
            top: 50%;
            width: 2.213333rem;
            height: 1.253333rem;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }

  .typeTitle {
    padding: 0 0.266667rem;
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #333333;
    font-weight: bold;
    &.typePd {
      padding-top: 10px;
    }
  }

  .more-goods {
    display: flex;
    margin-top: 0.665rem;
    justify-content: center;

    .btn {
      border-radius: 0.4256rem;
      border: 1px solid #f2f2f2;
      display: flex;
      height: 0.8512rem;
      padding: 0 0.5586rem;
      background: #fff;
      justify-content: center;
      align-items: center;
      font-size: 12px;

      i {
        font-size: 10px;
        margin-left: 0.1064rem;
      }
    }
  }

  /deep/ .vue-waterfall {
    overflow: hidden;
  }
  .MySkeleton{
    
    &.skeleton-list{
      padding: 0 0.266667rem 0;
    }
    .box {
          display: flex;
          position: relative;
          // width: 100%;
          height: 2.666667rem;
          background: #fff;
          margin-top: 0.4rem;
          box-sizing: border-box;
          box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.06);
          .img-box {
              position: relative;

              .img-box-content {
                  margin-top: 0.266667rem;
                  margin-left: 0.213333rem;
                  background: #fff;
                  height: 2.133333rem;
                  width: 3.2rem;
                  overflow: hidden;
                  position: relative;
                  display: flex;
                  justify-content: center;
              }
          }

          .goods-content-common {
              padding: 0.266667rem;
              flex: 1;
              
          }
        
      }
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/goodsType.vue